import { useCallback } from 'react';

import { ChipButton } from './FollowUpChip.styles';
import { TFollowUpChipProps } from './types';

const FollowUpChip = ({ text, index, disabled = false, onClick }: TFollowUpChipProps) => {
  const handleClick = useCallback(() => {
    if (!disabled) {
      onClick(text);
    }
  }, [disabled, onClick, text]);

  return (
    <ChipButton $index={index} disabled={disabled} onClick={handleClick} data-testid={`follow-up-chip-${index}`}>
      {text}
    </ChipButton>
  );
};

export default FollowUpChip;
